export const SHARE_CARD_IMAGE_TYPES = {
    GAME_RESULT: 1, // 參加結果圖
    CUSTOM: 2, // 自訂圖片
    WORK_PAGE: 3 // 作品頁
};
